import React from 'react';
import { Box } from '@material-ui/core';
import PropTypes from 'prop-types';

import { Chip } from 'src/components';

const SpeciesTypeFilter = ({ speciesType, setSpeciesType, showAllOption = true,
  labels = { left: 'flora', right: 'fauna', all: 'total' } }) => {
  const left = labels.left;
  const right = labels.right;
  const all = labels.all;

  return <>
    {showAllOption &&
      <>
        <Chip
          color={speciesType === all ? 'secondary' : 'gray'}
          label={all}
          size="small"
          onClick={() => setSpeciesType(all)}
        />
        <Box mx={0.5} />
      </>
    }
    <Chip
      color={speciesType === left ? 'flora.primary.main' : 'gray'}
      label={left}
      size="small"
      onClick={() => setSpeciesType(left)}
    />
    <Box mx={0.5} />
    <Chip
      color={speciesType === right ? 'fauna.primary.main' : 'gray'}
      label={right}
      size="small"
      onClick={() => setSpeciesType(right)}
    />
  </>;
};

SpeciesTypeFilter.propTypes = {
  speciesType: PropTypes.string,
  setSpeciesType: PropTypes.func,
  showAllOption: PropTypes.bool,
  labels: PropTypes.object,
};


export { SpeciesTypeFilter };